import {Dialog} from '@base-ui/react/dialog';
import type {ReactNode, Ref} from 'react';

import {twx} from '@/utils/tailwindUtils';

import DialogBase from '../base/DialogBase';
import DialogCloseButton from '../base/DialogCloseButton';

export type PopupFullPageProps = {
    open?: boolean;
    onOpenChange?: (open: boolean) => void;
    onAnimationEnd?: () => void;
    children: ReactNode;
    className?: string;
    showCloseButton?: boolean;
    closeButtonClassName?: string;
    contentRef?: Ref<HTMLDivElement>;
    animateFromBottom?: boolean;
    modal?: boolean;
    'aria-label'?: string;
    'aria-labelledby'?: string;
    'aria-describedby'?: string;
};

const PopupFullPage = ({
    open = true,
    onOpenChange,
    onAnimationEnd,
    children,
    className,
    showCloseButton = false,
    closeButtonClassName,
    contentRef,
    animateFromBottom = false,
    modal = true,
    'aria-label': ariaLabel,
    'aria-labelledby': ariaLabelledBy,
    'aria-describedby': ariaDescribedBy,
}: PopupFullPageProps) => {
    const handleOpenChangeComplete = (isOpen: boolean) => {
        if (!isOpen) onAnimationEnd?.();
    };

    return (
        <DialogBase
            open={open}
            onOpenChange={onOpenChange}
            onOpenChangeComplete={handleOpenChangeComplete}
            modal={modal}
        >
            <Dialog.Popup
                ref={contentRef}
                className={twx(
                    'fixed top-0 right-0 left-0 isolate z-104 h-screen overflow-auto w-full bg-tnemec-black',
                    animateFromBottom && 'animate-slide-from-bottom',
                    className
                )}
                aria-label={ariaLabel}
                aria-labelledby={ariaLabelledBy}
                aria-describedby={ariaDescribedBy}
                initialFocus={false}
            >
                {showCloseButton && <DialogCloseButton className={closeButtonClassName} />}
                {children}
            </Dialog.Popup>
        </DialogBase>
    );
};

export default PopupFullPage;
